import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { ClassroomsOrg, School } from 'types/school';
import { Classroom } from 'types/classroom';
import { BOLabels, UserLocale } from 'types/user';
import { Schoolyear } from 'types/schoolyear';
import { deserializeSchoolyear } from 'queries/schoolyears/serializer';
import { OldCustomFieldDefinition } from 'types/oldCustomField';

function fetch({ userId, token }: { userId: string; token: string }) {
  const requestURL = `/shares/${userId}/emploi-du-temps/${token}`;
  return request(requestURL, {
    method: 'GET',
  }).then<Data>(data => ({
    ...data,
    schoolyear: deserializeSchoolyear(data.schoolyear, data.tz),
  }));
}

interface Data {
  classrooms: Classroom[];
  school: School;
  schoolyear: Schoolyear;
  boLabels: BOLabels;
  permission: 'read' | 'write';
  tz: string;
  locale: UserLocale;
  country: string;
  referentielId: string;
  customFields?: OldCustomFieldDefinition[];
  classroomsOrg: ClassroomsOrg;
  weektableId: string;
}

export function useGetShareEDT(userId: string, token: string) {
  return useQuery({
    queryKey: ['edtShare'],
    queryFn: () =>
      fetch({
        userId,
        token,
      }),

    // 10 mins
    staleTime: 10 * (60 * 1000),

    // 15 mins
    gcTime: 15 * (60 * 1000),

    refetchOnWindowFocus: false,

    retry: (failCount, err) => {
      if (err?.response?.status === 404) {
        return false;
      }
      return failCount < 1;
    },
  });
}
